// Brand assets matching screenshot version
export const LOGO_URL = "/assets/logo.png";

export const COMPANY = {
  name: "ALearnIndia",
  tagline: "Learn Something New",
  phone: "+91 77601 69191",
  phoneTel: "+917760169191",
  email: "contact@alearnindia.com",
  address: "Jp nagar 2nd phase 20th Main Bangalore 560078",
  addressShort: "Bangalore, India",
};
